/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntroductionInquiryDto } from '../../models/introduction-inquiry-dto';
import { UpdateIntroductionInquiryDto } from '../../models/update-introduction-inquiry-dto';

export interface IntroductionInquiryControllerUpdateStatus$Params {
  id: string;
      body: UpdateIntroductionInquiryDto
}

export function introductionInquiryControllerUpdateStatus(http: HttpClient, rootUrl: string, params: IntroductionInquiryControllerUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<IntroductionInquiryDto>> {
  const rb = new RequestBuilder(rootUrl, introductionInquiryControllerUpdateStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntroductionInquiryDto>;
    })
  );
}

introductionInquiryControllerUpdateStatus.PATH = '/api/introduction-inquiry/{id}/status';
